import { useParams } from 'react-router-dom';
import { getItem } from 'helpers/store';
import { useGetSharedListContactByIdQuery } from 'services/sharedListV2';

export const useNotesDrawerContact = (contactId, listInfo) => {
  const { slug } = useParams();

  const password = listInfo?.passwordProtected ? getItem(`sharedListPwd-${slug}-${listInfo?.id}`) : '';

  const { data: contact, isFetching } = useGetSharedListContactByIdQuery(
    {
      contactId,
      slug,
      password,
    },
    {
      skip: !contactId || !slug,
    },
  );

  return {
    contact,
    isFetching,
  };
};
